/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {divideBySpaces} from 'helpers/numberHelpers';

import {SensorGroupCollection} from '../types';

interface SubRowData {
  collection: SensorGroupCollection;
  columnKey: string;
}

const getSubRows = (subRowData: SubRowData[]): TanStackTableData[] => {
  const result: TanStackTableData[] = [];

  subRowData.forEach(({collection, columnKey}) => {
    const keys = Object.keys(collection);
    keys.sort((a, b) => collection[b] - collection[a]);

    keys.forEach((name, index) => {
      const value = divideBySpaces(collection[name]);
      if (result[index]) {
        result[index] = {
          ...result[index],
          [columnKey]: {[name]: value},
        };
      } else {
        result[index] = {
          [columnKey]: {[name]: value},
        };
      }
    });
  });

  return result;
};

export {getSubRows};
